import { Component, OnInit } from '@angular/core';
import { QueryEditorBase } from 'src/core/models/query/query-editor-base';
import { Operators } from 'src/core/models/request/operator.enum';
import { Observable } from 'rxjs';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';
import { map } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { IntegerQueryItemDto } from 'src/core/models/query/integer-query-item.dto';
import { GenericLookupTypeService } from 'src/core/services/generic-lookup-type/generic-lookup-type.service';
import { CallReleasingParty } from 'src/core/models/generic-lookup-type/call/call-releasing-party.glt';

@Component({
    selector: 'ca-query-tree-node-conversation-releasing-party',
    templateUrl: './query-tree-node-conversation-releasing-party.component.html',
    styleUrls: ['./query-tree-node-conversation-releasing-party.component.scss'],
    standalone: false
})
export class QueryTreeNodeConversationReleasingPartyComponent extends QueryEditorBase implements OnInit {
  releasingParties$: Observable<GenericLookupDto[]>;
  currentReleasingPartyCode: string;

  payload: IntegerQueryItemDto;

  constructor(private operators: Operators, private store: Store, private genericLookupService: GenericLookupTypeService) {
    super();

    this.releasingParties$ = this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(CallReleasingParty)));
  }

  operatorChanged() {
    this.node.isDirty = true;
  }

  valueChanged() {
    this.node.isDirty = true;
    this.payload.genericLookupCode = this.genericLookupService.findGenericLookupWithId(this.payload.value)?.code;
  }

  ngOnInit() {
    this.payload = this.node.categoryItem.payload as IntegerQueryItemDto;
    this.releasingParties$.subscribe((releasingParties: GenericLookupDto[]) => {
      this.currentReleasingPartyCode = releasingParties.find(x => x.id == this.payload.value).code;
      this.payload.genericLookupCode = this.currentReleasingPartyCode;
    });

    this.node.validationStatus = true;
  }
}
